/**
 * Mainbeauty — entry bundle: thư viện ngoài + mọi module của theme.
 */
import "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // modal + toast (kèm Popper)
import "owl.carousel";
import "./smoothScroll.js";
import "./scrollReveal.js";
import "./mainbt.js";
import "./mainbt-form-validate.js";
import "./mainbt-select.js";
import "./mainbt-nav.js";
import "./mainbt-anchor.js";
import "./mainbt-consult.js";
import "./mainbt-login.js";
import "./mainbt-notify.js";
import "./mainbt-seats.js";
import "./mainbt-lp-nav.js";
import "./mainbt-collapse.js";
import "./mainbt-more.js";
import "./mainbt-carousel.js";
import "./mainbt-lightbox.js";
import "./mainbt-video.js";
import "./mainbt-course.js";
import "./mainbt-blog.js";
import "./mainbt-webinar.js";
import "./mainbt-share.js";
import "./mainbt-contact.js";
import "./mainbt-motion.js";
